module.exports = __webpack_public_path__ + "img/img-2.e67b2e19.webp";